
export const GET_REPORT_LIST = "get_Report_list";
export const GET_REPORT_LIST_SUCCESS = "get_Report_list_success";
export const CHANGE_REPORT_ACTIVE_PAGE = "change_Report_active_page";
export const GET_REPORT_BLOCK = "get_Report_Block";
export const GET_REPORT_BLOCK_SUCCESS = "get_Report_Block_success";
